var map = {
	"./culik/surat-list-penduduk-min.png": "b6b6",
	"./menanga/surat-list-penduduk-min.png": "0687",
	"./remun-surat/surat-list-penduduk-min.png": "8eea",
	"./sangsit/surat-list-penduduk-min.png": "56ed",
	"./sibetan/surat-list-penduduk-min.png": "0094"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44a4";